//export const API_BASE_URL = "https://newsapp.aasmo.in/api/v1/admin";
// export const API_BASE_URL = "https://4cxxz2c5-8004.inc1.devtunnels.ms/api/v1/admin"; // replace if needed
export const API_BASE_URL = " https://backend.xpressnews.in/api/v1/admin";
export const API_ENDPOINT = {

  //public apis URL 
  ADMIN_REGISTER: `${API_BASE_URL}/register`,
  ADMIN_LOGIN: `${API_BASE_URL}/login`,
   GET_COUNTRIES: `${API_BASE_URL}/countries`,

     // CRUD for Countries
  CREATE_COUNTRY: `${API_BASE_URL}/countries`,
  UPDATE_COUNTRY: (id) => `${API_BASE_URL}/countries/${id}`,
  DELETE_COUNTRY: (id) => `${API_BASE_URL}/countries/${id}`,

  // CRUD for States
  CREATE_STATE: `${API_BASE_URL}/states`,
  UPDATE_STATE: (id) => `${API_BASE_URL}/states/${id}`,
  DELETE_STATE: (id) => `${API_BASE_URL}/states/${id}`,

  // CRUD for Cities
  CREATE_CITY: `${API_BASE_URL}/cities`,
  ALL_DELETE_CITY: `${API_BASE_URL}/bulkDeleteCities`,
  UPDATE_CITY: (id) => `${API_BASE_URL}/cities/${id}`,
  DELETE_CITY: (id) => `${API_BASE_URL}/cities/${id}`,

  GET_STATES_BY_COUNTRY: (countryId) => `${API_BASE_URL}/countries/${countryId}/states`,
  GET_CITIES_BY_STATE: (stateId) => `${API_BASE_URL}/states/${stateId}/cities`,
  GET_CATEGORIES: `${API_BASE_URL}/categories`,
GET_SUBCATEGORIES: (id) => `${API_BASE_URL}/subcategories?category=${id}`,

 
};
